module.exports = __webpack_public_path__ + "img/2-8.74c48074.png";